'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _types = require('@appbaseio/reactivecore/lib/utils/types');

var _types2 = _interopRequireDefault(_types);

var _TreeList = require('../../../styles/TreeList');

var _HierarchicalMenuListItemComponent = require('./HierarchicalMenuListItemComponent');

var _HierarchicalMenuListItemComponent2 = _interopRequireDefault(_HierarchicalMenuListItemComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HierarchicalMenuComponent(_ref) {
	var listArray = _ref.listArray,
	    _ref$parentPath = _ref.parentPath,
	    parentPath = _ref$parentPath === undefined ? '' : _ref$parentPath,
	    _ref$isExpanded = _ref.isExpanded,
	    isExpanded = _ref$isExpanded === undefined ? false : _ref$isExpanded,
	    listItemProps = _ref.listItemProps;

	if (!Array.isArray(listArray) || listArray.length === 0) {
		return null;
	}

	return _react2.default.createElement(
		_TreeList.HierarchicalMenuList,
		{ className: '' + (isExpanded ? '--open' : ''), isSelected: isExpanded },
		listArray.map(function (listItem) {
			return _react2.default.createElement(_HierarchicalMenuListItemComponent2.default, _extends({
				key: parentPath + '__' + JSON.stringify(listItem),
				parentPath: parentPath,
				listItem: listItem
			}, listItemProps));
		})
	);
}

HierarchicalMenuComponent.propTypes = {
	listArray: _propTypes2.default.arrayOf(_types2.default.rawData), // array of objects
	parentPath: _types2.default.string,
	isExpanded: _types2.default.bool,
	listItemProps: _types2.default.rawData
};
exports.default = HierarchicalMenuComponent;